module.exports = __webpack_public_path__ + "img/5-low.3898a1a6.jpg";